<template>
    <div>
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-card flat class="text-xs-center">
            <v-card-title class="justify-center primary">
                <v-toolbar-title id="titulocard">Listado Desconclusiones</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <DataTable :url="urlListado" :columns="columns"
                           :params="displayInputs" :order="[]" @apiDT="apiDT = $event" @Cancelar="CancelarShow"></DataTable>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
    import DataTable from "@/components/pages/DataTableNet/DataTable";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            DataTable
        },
        data: function () {
            return {
                showcargando: true,
                urlListado: 'ReporteGeneral/Desconclusion',
                apiDT: null,
                columns: [
                    { name: 'FechaSolicituds', data: 'FechaSolicituds', title: "Fecha Solicitud" },
                    { name: 'ObsSolicitud', data: 'ObsSolicitud', title: "Observaciones Solicitud" },
                    { name: 'UsuarioSolicita', data: 'UsuarioSolicita', title: "Usuario Solicita" },
                    { name: 'Respuesta', data: 'Respuesta', title: "Respuesta" },
                    { name: 'FechaDesconclusion', data: 'FechaDesconclusion', title: "Fecha Desconclusión" },
                    { name: 'ObsDesconclusion', data: 'ObsDesconclusion', title: "Observaciones Desconclusión" },
                    { name: 'UsuarioAutoriza', data: 'UsuarioAutoriza', title: "Usuario Autoriza" },
                ],
                displayInputs: {
                    nrreporte: 0,
                    svindice: 0,
                },
            }
        },
        methods: {
            ...mapMutations(["changeReporteMenuOption"]),
            reloadTable() {
                if (this.apiDT != null) {
                    this.apiDT.ajax.reload(null, false);
                    this.apiDT.columns.adjust().responsive.recalc();
                }
            },
            CancelarShow() {
                this.showcargando = false;
            }
        },
        computed: {
            ...mapState({ drawer: state => state.drawer }),
            ...mapState(['domain', 'informationPage']),
            DRAWER_STATE: {
                get() {
                    return this.drawer
                },
            },
        },
        mounted() {
            //this.changeReporteMenuOption(this.$route.name);
            this.changeReporteMenuOption("Desconclusión");
        },
        async created() {
            let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.displayInputs = {
                nrreporte: datos.nrreporte,
                svindice: datos.svindice,
            };
            this.reloadTable();
        },
        async beforeMount() {
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '318').then(response => {
                if (response.data.length > 0) {
                } else {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                }

            });
        }
    }
</script>